var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F0E0FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.75 22.3465V25.2C33.75 28.7622 33.75 30.5434 32.8428 31.792C32.5499 32.1952 32.1952 32.5499 31.792 32.8428C30.5434 33.75 28.7622 33.75 25.2 33.75H22.8C19.2378 33.75 17.4566 33.75 16.208 32.8428C15.8048 32.5499 15.4501 32.1952 15.1572 31.792C14.25 30.5434 14.25 28.7622 14.25 25.2V22.3465C14.25 21.7925 14.25 21.5155 14.2758 21.2825C14.4946 19.3054 16.0554 17.7446 18.0325 17.5258C18.2655 17.5 18.5425 17.5 19.0965 17.5H19.3056C19.505 17.5 19.6667 17.3383 19.6667 17.1389C19.6667 15.5434 20.9601 14.25 22.5556 14.25H25.4444C27.0399 14.25 28.3333 15.5434 28.3333 17.1389C28.3333 17.3383 28.495 17.5 28.6944 17.5H28.9035C29.4575 17.5 29.7345 17.5 29.9675 17.5258C31.9446 17.7446 33.5054 19.3054 33.7242 21.2825C33.75 21.5155 33.75 21.7925 33.75 22.3465ZM24 21.5C22.067 21.5 20.5 23.067 20.5 25C20.5 26.933 22.067 28.5 24 28.5C25.933 28.5 27.5 26.933 27.5 25C27.5 23.067 25.933 21.5 24 21.5Z",
    fill: "#4C0A82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdNext);
export default __webpack_public_path__ + "static/media/id_next.c4cfb01a431df5df47889e3df449687f.svg";
export { ForwardRef as ReactComponent };